/**
 * 接口文档
 * http://192.168.3.101/weixu/doc/blob/master/webot_new/cent%E6%B6%88%E6%81%AF%E6%A0%BC%E5%BC%8F:cent_msg.md
 * https://github.com/centrifugal/centrifuge-js
 */

import Centrifuge from 'centrifuge'
import SockJS from 'sockjs-client'
import { postSocketRefresh } from '@/api/chat'

export default class Socket {
    constructor ({
        entryKey,
        uid,
        url,
        channel,
        token,
        listeners,
        connectListener,
        disconnectListener
    }) {
        this.entryKey = entryKey
        this.uid = uid
        this.url = url
        this.channel = channel
        this.token = token
        this.connectListener = connectListener
        this.disconnectListener = disconnectListener
        this.listeners = listeners
        this.instance = null
        this.subscribe = null
    }

    static getInstance () {
        if (!this.instance) {
            this.instance = new Socket(...arguments)
        }
        return this.instance
    }

    get config () {
        const result = {
            sockjs: SockJS,
            onRefresh: async (ctx, cb) => {
                try {
                    const token = await postSocketRefresh(this.entryKey, this.uid)
                    /**
                     * param: {"status": 200, "data": {"token": "JWT"}}
                     */
                    cb({
                        status: 200,
                        data: {
                            token
                        }
                    })
                    this.token = token
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }
            }
        }
        if (this.url && this.url.indexOf('ws') !== 0) {
            result.sockjsTransports = ['xhr-polling']
        }
        return result
    }

    init () {
        this.instance = new Centrifuge(this.url, this.config)
        if (this.token) {
            this.instance.setToken(this.token)
        }
        this.instance.on('connect', this.connectListener)
        this.instance.on('disconnect', this.disconnectListener)
        this.subscribe = this.instance.subscribe(this.channel, this.listeners)
        this.instance.connect()
    }

    on (type, listener) {
        this.subscribe.on(type, listener)
    }

    disconnect () {
        this.instance.disconnect()
    }

    unsubscribe () {
        this.instance.unsubscribe()
    }

    resubscribe () {
        this.subscribe = this.instance.subscribe(this.channel)
    }
}
